import { Company } from "../gateway/Company/Company";

// O mesmo recorte de licença que a listagem sempre manda. Sem ele o painel contaria uma população
// diferente da lista — e o primeiro número que o usuário confere é o total ao lado de "Empresas".
const STATUS_DA_TELA = ["ATIVO", "INATIVO", "BLOQUEADO"];

/**
 * Métricas da carteira do Domínio para o painel lateral da tela de integração.
 *
 * Ignora os filtros ativos na tela de propósito: o painel é visão geral da carteira, não do
 * recorte. Se um dia passar a acompanhar o filtro, é `filters` que muda aqui — o endpoint já
 * aceita os mesmos filtros da listagem.
 */
export class GetDominioMetricsUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ accountingId } = {}) {
        const payload = this.sanitizeInput({ accountingId });
        if (!payload.accountingId) return null;

        return await this.CompanyGateway.integrationKpis({
            system: "dominio",
            accountingId: payload.accountingId,
            filters: { license: STATUS_DA_TELA }
        });
    }

    sanitizeInput({ accountingId = "" } = {}) {
        return { accountingId: String(accountingId || "").trim() };
    }
}
